/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { AnteprimaContributoDTO } from '../model/models';
import { AssegnazioneArticoloCedolaListFilter } from '../model/models';
import { DepubblicaTipoPraticaForm } from '../model/models';
import { DisattivaOtpTipoPraticaForm } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelAssegnazioneArticoloCedolaWithChainDTO } from '../model/models';
import { PagedModelTipoPraticaDTO } from '../model/models';
import { ReadinessReportDTO } from '../model/models';
import { RiapriTipoPraticaForm } from '../model/models';
import { RipristinaTipoPraticaForm } from '../model/models';
import { TipoPraticaCreationForm } from '../model/models';
import { TipoPraticaDTO } from '../model/models';
import { TipoPraticaGraduatoriaForm } from '../model/models';
import { TipoPraticaIstitutoPlessoAssegnazioneSelectDTO } from '../model/models';
import { TipoPraticaIstitutoPlessoSelectDTO } from '../model/models';
import { TipoPraticaIstitutoSelectDTO } from '../model/models';
import { TipoPraticaListFilter } from '../model/models';
import { TipoPraticaPatchForm } from '../model/models';
import { TipoPraticaPolicyForm } from '../model/models';
import { TipoPraticaStatoTransitionForm } from '../model/models';
import { TipoPraticaStatoTransitionResponseDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface AnteprimaContributoGraduatoriaRequestParams {
    id: string;
    tipoPraticaGraduatoriaForm: TipoPraticaGraduatoriaForm;
}

export interface CreateTipoPraticaRequestParams {
    tipoPraticaCreationForm: TipoPraticaCreationForm;
}

export interface DeleteTipoPraticaRequestParams {
    id: string;
}

export interface DepubblicaTipoPraticaRequestParams {
    id: string;
    depubblicaTipoPraticaForm: DepubblicaTipoPraticaForm;
}

export interface DisattivaOtpTipoPraticaRequestParams {
    id: string;
    disattivaOtpTipoPraticaForm: DisattivaOtpTipoPraticaForm;
}

export interface GetTipoPraticaRequestParams {
    id: string;
}

export interface GetTipoPraticaAssegnazioniSelectRequestParams {
    idTipoPratica: string;
    istitutoId?: string;
    plessoId?: string;
}

export interface GetTipoPraticaIstitutiSelectRequestParams {
    idTipoPratica: string;
}

export interface GetTipoPraticaPlessiSelectRequestParams {
    idTipoPratica: string;
    istitutoId?: string;
}

export interface GetTipoPraticaValidazioneRequestParams {
    id: string;
}

export interface ListTipiPraticaRequestParams {
    filter: TipoPraticaListFilter;
    pageable: Pageable;
}

export interface ListTipoPraticaArticoliCedoleRequestParams {
    idTipoPratica: string;
    filter: AssegnazioneArticoloCedolaListFilter;
    pageable: Pageable;
}

export interface RiapriTipoPraticaRequestParams {
    id: string;
    riapriTipoPraticaForm: RiapriTipoPraticaForm;
}

export interface RipristinaTipoPraticaRequestParams {
    id: string;
    ripristinaTipoPraticaForm: RipristinaTipoPraticaForm;
}

export interface TransitionTipoPraticaStatoRequestParams {
    id: string;
    tipoPraticaStatoTransitionForm: TipoPraticaStatoTransitionForm;
}

export interface UpdateTipoPraticaRequestParams {
    id: string;
    tipoPraticaPatchForm: TipoPraticaPatchForm;
}

export interface UpsertTipoPraticaGraduatoriaRequestParams {
    id: string;
    tipoPraticaGraduatoriaForm: TipoPraticaGraduatoriaForm;
}

export interface UpsertTipoPraticaPolicyRequestParams {
    id: string;
    tipoPraticaPolicyForm: TipoPraticaPolicyForm;
}


export interface TipoPraticaControllerServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Anteprima read-only dell\&#39;importo base contributo su un caso finto, a partire da una configurazione anche non ancora salvata. Non scrive nulla e non legge pratiche reali. SUPERADMIN-only.
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{id}/graduatoria/anteprima-contributo
* @param requestParameters
     */
    anteprimaContributoGraduatoria(requestParameters: AnteprimaContributoGraduatoriaRequestParams, extraHttpRequestParams?: any): Observable<AnteprimaContributoDTO>;

    /**
     * Crea un nuovo TipoPratica (SUPERADMIN). Forza stato&#x3D;IN_ATTESA.
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica
* @param requestParameters
     */
    createTipoPratica(requestParameters: CreateTipoPraticaRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaDTO>;

    /**
     * Elimina hard un TipoPratica (SUPERADMIN). Fallisce con 409 se esistono pratiche associate.
     * 
     * @endpoint delete /api/v1/gestione/tipi-pratica/{id}
* @param requestParameters
     */
    deleteTipoPratica(requestParameters: DeleteTipoPraticaRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Depubblica atomicamente un bando (RICEZIONE_RICHIESTE → IN_ATTESA) (SUPERADMIN). Riporta il bando in bozza per correggere errori di configurazione: scongela i campi semantic-frozen e azzera data_apertura/data_chiusura (così il cron di schedulazione non lo riapre). Incondizionata rispetto alle pratiche associate (nessun guard zero-pratiche): le domande già inviate restano intatte ma non lavorabili finché il bando è IN_ATTESA, e tornano lavorabili alla ri-pubblicazione. 422 se il bando non è in RICEZIONE_RICHIESTE, 409 su version stale.
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{id}/depubblica
* @param requestParameters
     */
    depubblicaTipoPratica(requestParameters: DepubblicaTipoPraticaRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaDTO>;

    /**
     * Disattiva atomicamente la conferma via OTP di un bando (SUPERADMIN). Spegne la policy (tipo_conferma_pratica → NESSUNO) e rimuove l\&#39;attributo del canale SYSTEM_PRATICA_CANALE_RICEZIONE_OTP nella stessa transazione. Esiste perché i due guard del paired bidirezionale si bloccano a vicenda su un bando pubblicato: cancellare l\&#39;attributo esige policy≠OTP, disattivare la policy esige attributo assente, quindi nessun ordine di operazioni funziona. Idempotente: un bando già senza OTP non è un errore. 409 su version stale della policy.
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{id}/disattiva-otp
* @param requestParameters
     */
    disattivaOtpTipoPratica(requestParameters: DisattivaOtpTipoPraticaRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaDTO>;

    /**
     * Dettaglio di un TipoPratica per id (include policy e graduatoria)
     * Audience: SUPERADMIN + OP_COMUNE (sola lettura). L\&#39;OP_COMUNE vede i bandi dei propri comuni gestiti; fuori scope → 403. Tutti gli altri endpoint di configurazione del bando restano SUPERADMIN-only.
     * @endpoint get /api/v1/gestione/tipi-pratica/{id}
* @param requestParameters
     */
    getTipoPratica(requestParameters: GetTipoPraticaRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaDTO>;

    /**
     * Lista compatta (id + classe + sezione) delle assegnazioni del bando, ordinata per classe/sezione. Filtri opzionali ?istituto_id&#x3D; e ?plesso_id&#x3D; per restringere; se entrambi presenti, plesso_id e\&#39; usato e istituto_id solo come scope di sicurezza.
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/assegnazioni/select
* @param requestParameters
     */
    getTipoPraticaAssegnazioniSelect(requestParameters: GetTipoPraticaAssegnazioniSelectRequestParams, extraHttpRequestParams?: any): Observable<Array<TipoPraticaIstitutoPlessoAssegnazioneSelectDTO>>;

    /**
     * Lista compatta (id + nome) degli istituti del bando, ordinata per nome. Pensata per popolare select / dropdown nel frontend.
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/select
* @param requestParameters
     */
    getTipoPraticaIstitutiSelect(requestParameters: GetTipoPraticaIstitutiSelectRequestParams, extraHttpRequestParams?: any): Observable<Array<TipoPraticaIstitutoSelectDTO>>;

    /**
     * Lista compatta (id + nome) dei plessi del bando, ordinata per nome. Filtro opzionale ?istituto_id&#x3D; per restringere ai plessi di un singolo istituto.
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/plessi/select
* @param requestParameters
     */
    getTipoPraticaPlessiSelect(requestParameters: GetTipoPraticaPlessiSelectRequestParams, extraHttpRequestParams?: any): Observable<Array<TipoPraticaIstitutoPlessoSelectDTO>>;

    /**
     * Validazione di pubblicabilità del TipoPratica: report read-only delle issue (errors + warnings) che il transition di pubblicazione valuterebbe. SUPERADMIN-only.
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{id}/validazione
* @param requestParameters
     */
    getTipoPraticaValidazione(requestParameters: GetTipoPraticaValidazioneRequestParams, extraHttpRequestParams?: any): Observable<ReadinessReportDTO>;

    /**
     * Lista cross-comune di tutti i TipoPratica (SUPERADMIN-only). Filtri opzionali: comune_id, codice, tipologia, stato, visualizzazione, q, fase. Default sort: codice ASC.
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica
* @param requestParameters
     */
    listTipiPratica(requestParameters: ListTipiPraticaRequestParams, extraHttpRequestParams?: any): Observable<PagedModelTipoPraticaDTO>;

    /**
     * Lista flat paginata degli articoli cedola di un bando (cross-Assegnazione/Plesso/Istituto). Filtri opzionali per restringere a un livello: istituto_id, plesso_id, assegnazione_id, classe, sezione. Filtri contenuto: area (containsCi), editore (eq), attivo (default strict true), q (containsCi titolo+editore+note). Default sort: area ASC, titolo ASC. Ritorna DTO arricchito con la chain scolastica.
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/articoli-cedole
* @param requestParameters
     */
    listTipoPraticaArticoliCedole(requestParameters: ListTipoPraticaArticoliCedoleRequestParams, extraHttpRequestParams?: any): Observable<PagedModelAssegnazioneArticoloCedolaWithChainDTO>;

    /**
     * Riapre atomicamente un bando (VALUTAZIONE_RICHIESTE → RICEZIONE_RICHIESTE) impostando una nuova data_chiusura futura e obbligatoria (SUPERADMIN). Garantisce l\&#39;invariante anti-loop col task di schedulazione.
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{id}/riapri
* @param requestParameters
     */
    riapriTipoPratica(requestParameters: RiapriTipoPraticaRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaDTO>;

    /**
     * Ripristina atomicamente un bando ARCHIVIATA allo stato memorizzato al momento dell\&#39;archiviazione (con ricontrollo della proiezione graduatoria) (SUPERADMIN). Seam fuori-policy: il generico PATCH /stato non può uscire da ARCHIVIATA. 422 se il bando non è ARCHIVIATA, 409 su version stale.
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{id}/ripristina
* @param requestParameters
     */
    ripristinaTipoPratica(requestParameters: RipristinaTipoPraticaRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaDTO>;

    /**
     * Cambia lo stato di un TipoPratica (transizione governata da policy). Per le transizioni pre-pubblicazione → post-pubblicazione include warning sui satelliti orfani (Fase 4.b).
     * 
     * @endpoint patch /api/v1/gestione/tipi-pratica/{id}/stato
* @param requestParameters
     */
    transitionTipoPraticaStato(requestParameters: TransitionTipoPraticaStatoRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaStatoTransitionResponseDTO>;

    /**
     * Aggiorna un TipoPratica esistente (partial update)
     * 
     * @endpoint patch /api/v1/gestione/tipi-pratica/{id}
* @param requestParameters
     */
    updateTipoPratica(requestParameters: UpdateTipoPraticaRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaDTO>;

    /**
     * Upsert della graduatoria (5 enum scoring/ranking + 2 scalari finanziamento) di un TipoPratica
     * 
     * @endpoint put /api/v1/gestione/tipi-pratica/{id}/graduatoria
* @param requestParameters
     */
    upsertTipoPraticaGraduatoria(requestParameters: UpsertTipoPraticaGraduatoriaRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaDTO>;

    /**
     * Upsert della policy (flag boolean) di un TipoPratica
     * 
     * @endpoint put /api/v1/gestione/tipi-pratica/{id}/policy
* @param requestParameters
     */
    upsertTipoPraticaPolicy(requestParameters: UpsertTipoPraticaPolicyRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaDTO>;

}
